/**
 * ノート用ファイルアップロードのヘルパー。
 *
 * purpose=note は register 不要（URL を Markdown 記法で本文へ直接埋め込む）
 * ため、共通の `uploadFileDirect` に委譲するだけの薄い包み。ノート固有の
 * 上限超過メッセージをここで与える。
 */
import {
  uploadFileDirect,
  type InitiateUploadTrigger,
  type UploadedFile,
} from "../../../utils/s3DirectUpload";

export type UploadedNoteFile = UploadedFile;

/**
 * ファイル 1 件を purpose=note で S3 へアップロードし、公開 URL を返す。
 * 画像に限らず任意のファイルを扱えるが、presigned POST のシングル
 * アップロード上限（50MB）内を前提とする。
 *
 * @param initiate uploadApi の initiateUpload mutation trigger（`.unwrap()` 可能なもの）
 */
export const uploadNoteFile = async (
  initiate: InitiateUploadTrigger,
  file: File,
): Promise<UploadedNoteFile> =>
  uploadFileDirect(initiate, file, {
    purpose: "note",
    tooLargeMessage: "ノートに添付できるファイルは 50MB 未満のみです",
  });
